export default {
    methods: {
        async getFileContent(fileId, file_type, query = '') {
            return await this.$http.get(`/v2/file/${fileId}/${file_type}${query}`, {
                responseType: 'arraybuffer'
            });
        }
    }
};
